import FormularioRegistro from "../componentes/FormularioRegistro";

function Registro(){
    return <div>
        <FormularioRegistro />
    </div>
}

export default Registro;